export const commonEn = {
  appName: "Floline",
  loading: "Loading...",
  nav: {
    mainNavigation: "Main navigation",
    mobileNavigation: "Mobile navigation",
    skipToContent: "Skip to main content",
    dashboard: "Dashboard",
    home: "Home",
    aiCheckIn: "AI Check-in",
    aiCheckInShort: "AI Check-In",
    recordShort: "Record",
    stopShort: "Stop",
    transcribingShort: "Transcribing",
    timeline: "Timeline",
    journal: "Journal",
    trends: "Trends",
    settings: "Settings",
  },
  pageTitle: {
    dashboard: "Dashboard",
    aiCheckIn: "AI Check-in",
    checkIn: "Daily Check-in",
    timeline: "Timeline",
    events: "Journal",
    trends: "Trends",
    settings: "Settings",
    onboarding: "Onboarding",
    dataAccess: "Data Access",
    login: "Sign In",
    register: "Create Account",
    privacy: "Privacy Policy",
    terms: "Terms of Service",
    default: "Floline",
  },
  dailyNavigation: {
    today: "Today",
    previous: "Previous",
    next: "Next",
    goToToday: "Go to today",
    previousDay: "Previous day",
    nextDay: "Next day",
  },
  auth: {
    openUserMenu: "Open user menu",
    logIn: "Log in",
    signInWithMicrosoft: "Sign in with Microsoft",
    signInTitle: "Sign In to Floline",
    signInSubtitle: "Track your pain journey with ease",
    logOut: "Log Out",
    or: "or",
    modeSignIn: "Sign in",
    modeCreateAccount: "Create account",
    emailLabel: "Email address",
    emailPlaceholder: "you@example.com",
    inviteCodeLabel: "Invite code",
    inviteCodePlaceholder: "Enter your invite code",
    inviteCodeHint: "You need an invite code to create a new account.",
    betaInviteOnlyDisclaimer:
      "Beta access only: we are not accepting new users without a valid invite code.",
    sendLoginLinkButton: "Send login link",
    sendLoginCodeButton: "Send login code",
    createAccountButton: "Create account",
    sending: "Sending\u2026",
    magicLinkSentTitle: "Check your email",
    magicLinkSentDescription: "If the address is registered, you'll receive a login link shortly.",
    magicLinkSentDescriptionRegister: "Check your inbox for a sign-in link.",
    otpSentDescription: "If the address is registered, you'll receive a one-time code shortly.",
    otpSentHint: "Enter the one-time code below to continue.",
    emailAuthExpiresHint: "The code expires in 5 minutes.",
    otpCodeLabel: "One-time code",
    otpCodePlaceholder: "Enter 6-digit code",
    verifyCodeButton: "Verify code",
    verifyingCode: "Verifying...",
    useDifferentEmail: "Use different email",
    otpInvalidOrExpired: "Invalid or expired code. Please try again.",
    otpTooManyAttempts: "Too many attempts. Please request a new code.",
    tryAgain: "Send another link",
    invalidInviteCode: "Invalid invite code. Please check and try again.",
    genericError: "Something went wrong. Please try again.",
    networkError: "Network error. Please check your connection and try again.",
  },
  actions: {
    save: "Save",
    saving: "Saving...",
    cancel: "Cancel",
    back: "Go back",
    delete: "Delete",
    deleting: "Deleting...",
    yesDelete: "Yes, Delete",
    saveChanges: "Save Changes",
    close: "Close",
    later: "Later",
    install: "Install",
    update: "Update",
    dismiss: "Dismiss",
    send: "Send",
    confirm: "Confirm",
  },
  bodyRegions: {
    head_neck: "Head & Neck",
    shoulder: "Shoulder",
    upper_back: "Upper Back",
    lower_back: "Lower Back",
    chest: "Chest",
    abdomen: "Abdomen",
    hip: "Hip",
    arm: "Arm",
    hand: "Hand",
    leg: "Leg",
    foot: "Foot",
    pelvis_groin: "Pelvis/Groin",
    generalized: "Generalized (Whole Body)",
    other: "Other",
  },
  bodyZones: {
    head_face: "Head/Face",
    neck: "Neck",
    shoulder: "Shoulder",
    upper_back: "Upper Back",
    mid_back: "Mid Back",
    lower_back: "Lower Back",
    chest: "Chest",
    upper_abdomen: "Upper Abdomen",
    lower_abdomen: "Lower Abdomen",
    pelvis_groin: "Pelvis/Groin",
    glute: "Buttock/Glute",
    hip: "Hip",
    upper_arm: "Upper Arm",
    elbow: "Elbow",
    forearm: "Forearm",
    wrist: "Wrist",
    hand: "Hand",
    thigh: "Thigh",
    knee: "Knee",
    lower_leg: "Lower Leg",
    ankle: "Ankle",
    foot: "Foot",
    generalized: "Generalized (Whole Body)",
    other: "Other",
  },
  bodySurfaces: {
    front: "Front",
    back: "Back",
    both: "Both",
    unknown: "Not Specified",
  },
  laterality: {
    left: "Left",
    right: "Right",
    bilateral: "Both Sides",
    midline: "Center/Midline",
    unknown: "Not Specified",
  },
  lateralityShort: {
    left: "L",
    right: "R",
    bilateral: "B",
    midline: "",
    unknown: "",
  },
  timeOfDay: {
    morning: "Morning",
    afternoon: "Afternoon",
    evening: "Evening",
    night: "Night",
    unknown: "Not Specified",
  },
  doseUnits: {
    mg: "mg",
    g: "g",
    ml: "mL",
    mcg: "mcg",
    tablet: "tablet(s)",
    capsule: "capsule(s)",
    drop: "drop(s)",
    patch: "patch",
    other: "other",
  },
  painQualities: {
    aching: "Aching",
    burning: "Burning",
    cramping: "Cramping",
    dull: "Dull",
    electric: "Electric",
    hot: "Hot",
    itchy: "Itchy",
    numbness: "Numbness",
    pins_and_needles: "Pins & Needles",
    pressure: "Pressure",
    sharp: "Sharp",
    shooting: "Shooting",
    sore: "Sore",
    stabbing: "Stabbing",
    throbbing: "Throbbing",
    tingling: "Tingling",
    tight: "Tight",
  },
  export: {
    buttonLabel: "Export",
    title: "Export Pain Data",
    description: "Generate a report of your pain tracking data.",
    dateRange: "Date Range",
    startDate: "Start",
    endDate: "End",
    dateRangeTooLarge: "Date range cannot exceed 365 days.",
    format: "Format",
    options: "Options",
    includeDetailedData: "Include detailed daily data tables",
    omitNotes: "Omit personal notes (privacy)",
    generating: "Generating...",
    generateExport: "Generate Export",
    downloadSuccess: "File downloaded successfully!",
    downloadRecords: "({{count}} records)",
    formatLabels: {
      pdf: "PDF Report",
      csv: "CSV Data",
      text: "Text Summary",
    },
    formatDescriptions: {
      pdf: "Comprehensive report for healthcare providers",
      csv: "Raw data for spreadsheet analysis",
      text: "Brief summary for quick sharing",
    },
    datePresets: {
      last7days: "Last 7 days",
      last30days: "Last 30 days",
      last90days: "Last 90 days",
      last6months: "Last 6 months",
      lastYear: "Last year",
    },
  },
  painLocationEdit: {
    title: "Edit {{region}}",
    description: "Modify the pain details for this location",
    side: "Side",
    painLevel: "Pain Level",
    painScaleMin: "0 - No pain",
    painScaleMax: "10 - Worst",
    painType: "Pain Type",
    additionalDetails: "Additional Details (optional)",
    detailPlaceholder: "E.g., 'behind the knee', 'worse in the morning'...",
    deleteConfirm: "Delete this?",
    failedToSave: "Failed to save changes",
    failedToDelete: "Failed to delete",
    painDescription: {
      none: "No pain",
      mild: "Mild",
      moderate: "Moderate",
      severe: "Severe",
      worst: "Worst imaginable",
    },
  },
  manualEntry: {
    title: "Add Pain Entry",
    bodyRegion: "Body Region *",
    bodyRegionPlaceholder: "Select body region...",
    side: "Side",
    surface: "Surface",
    painIntensity: "Pain Intensity",
    scaleMax: "/ 10",
    scaleMinLabel: "No pain",
    scaleMaxLabel: "Severe",
    additionalNotes: "Additional Notes (Optional)",
    notesPlaceholder: "Any additional details about the pain...",
    addToCheckin: "Add to Check-in",
  },
  dailyRecord: {
    emptyTitle: "No Pain Recorded",
    emptyDescription: "No pain data was recorded for {{date}}.",
    addEntryForDay: "Add Entry for This Day",
    painFreeTitle: "Pain-Free Day Logged",
    painFreeDescription: "You logged {{date}} as pain-free.",
    editDay: "Edit Day",
    errorTitle: "Error Loading Record",
    bodyHeatmap: "Body Heatmap",
    painLocations: "Pain Locations",
    observations: "Observations",
    medications: "Medications",
    notes: "Notes",
    tags: "Tags",
  },
  pwa: {
    installTitle: "Install Floline",
    installDescription: "Track your pain offline with our app",
    installTitleMobile: "Install Floline on your phone",
    installDescriptionMobile: "Get faster launches, offline logging, and a smoother daily check-in.",
    installIosHint: "On iPhone: tap Share, then choose Add to Home Screen.",
    statusSyncing: "Syncing changes...",
    statusPending_one: "{{count}} change pending",
    statusPending_other: "{{count}} changes pending",
    statusOffline: "You're offline",
    statusOfflineWillSync_one: "You're offline • {{count}} change will sync when connected",
    statusOfflineWillSync_other: "You're offline • {{count}} changes will sync when connected",
    updateAvailableTitle: "Update available",
    updateAvailableDescription: "A new version is ready to install",
    offlineReadyTitle: "App ready for offline use",
    offlineReadyDescription: "Content has been cached locally",
  },
  bodyDiagram: {
    front: "Front",
    back: "Back",
    showFrontView: "Show front view",
    showBackView: "Show back view",
    diagramInstruction: "Click on a body region to select it",
    dualViewAriaLabel: "Body pain heatmap showing front and back views",
    frontDiagram: "Front view body diagram",
    backDiagram: "Back view body diagram",
  },
  painScale: {
    outOf10: "/ 10",
  },
  errors: {
    // Export errors
    signInToExport: "Please sign in to generate exports",
    invalidDateRange: "Invalid date range. Please check your start and end dates.",
    dateRangeTooLarge: "Date range is too large. Please select a shorter period.",
    insufficientData: "Not enough data in the selected date range to generate an export.",
    exportFailed: "Failed to generate export. Please try again.",
    unsupportedExportFormat: "Unsupported export format selected.",
    // Transcription errors
    signInToTranscribe: "Please sign in to transcribe audio",
    transcriptionUnavailable: "Transcription service is not available",
    unsupportedAudioFormat: "Unsupported audio format for transcription",
    transcriptionFailed: "Failed to transcribe audio. Please try again.",
    // Audio upload errors
    signInToUploadAudio: "Please sign in to upload audio recordings",
    audioUploadTooLarge: "Recording is too large. Maximum size is 50 MB",
    unsupportedAudioUploadFormat: "Unsupported audio format. Please try a different browser",
    // Extraction errors
    signInToExtract: "Please sign in to extract pain data",
    extractionUnavailable: "AI extraction service is not available",
    missingTranscript: "No transcript provided for extraction",
    transcriptTooLong: "Transcript is too long. Please shorten your message.",
    extractionFailed: "Failed to extract pain data. Please try again.",
    invalidAiResponse: "Received invalid response from AI service",
    // Consent-gated feature errors
    consentRequired:
      "This feature is disabled until you give consent in Settings.",
    consentRequiredAudioTranscription:
      "Audio transcription is disabled until you enable consent in Settings.",
    consentRequiredAiExtraction:
      "AI extraction is disabled until you enable consent in Settings.",
    consentRequiredAiInsights:
      "AI insights are disabled until you enable consent in Settings.",
  },
  exportSummary: {
    noPainData: "No pain data",
    avgRange: "Avg: {{avg}}/10, Range: {{min}}-{{max}}/10",
    noLocationsRecorded: "No locations recorded",
    noMedicationsRecorded: "No medications recorded",
    medicationsTracked: "{{count}} medication(s) tracked",
    exportFailedStatus: "Export failed ({{status}})",
    exportFailedGeneric: "Export generation failed. Please try again.",
  },
  landing: {
    signIn: "Sign in",
    getStarted: "Get started",
    overlineBadge: "Chronic pain management",
    headlineMap: "Map your pain.",
    headlineReclaim: "Reclaim your life.",
    subheadline: "Floline turns invisible pain into actionable data. Track patterns, identify triggers, and share precise reports with your care team — all in under 60\u00a0seconds a day.",
    ctaStartTracking: "Start tracking free",
    ctaSeeHow: "See how it works",
    cardWeeklyOverview: "Weekly Overview",
    cardLive: "Live",
    statAvgLevel: "Avg level",
    statTriggers: "Triggers",
    statTrend: "Trend",
    socialEntries: "pain entries tracked",
    socialConversations: "report better care conversations",
    socialCheckin: "average daily check-in",
    socialSatisfaction: "user satisfaction",
    featuresHeading: "Built for people who live with pain",
    featuresSubheading: "Floline is built specifically for chronic and acute pain tracking.",
    featureLogTitle: "60-second daily log",
    featureLogBody: "Body map, intensity slider, triggers, and notes — everything captured in a single focused flow. No bloat, no friction.",
    featurePatternsTitle: "Pattern intelligence",
    featurePatternsBody: "Spot correlations between pain levels, weather, sleep, medications and activities. See what actually helps — or hurts.",
    featureReportsTitle: "Doctor-ready reports",
    featureReportsBody: "Generate PDF summaries that your care team will actually find useful. Turn 'it hurts' into precise, data-backed dialogue.",
    ctaHeading: "Your pain deserves to be",
    ctaHeadingHighlight: "understood",
    ctaSubheading: "Start building your pain profile today. Free, private, and designed for real people managing real pain.",
    ctaCreateAccount: "Create free account",
    footerCopyright: "© {{year}} Floline. Built with empathy for people who live with pain.",
    footerPrivacy: "Privacy Policy",
    footerTerms: "Terms of Service",
  },
  legal: {
    privacyPolicy: "Privacy Policy",
    termsOfService: "Terms of Service",
    backToHome: "Back to home",
    lastUpdated: "Last updated: {{date}}",
    privacyTitle: "Privacy Policy",
    privacyIntro:
      "Floline (\"we\", \"us\", \"the Service\") is a health-data application that helps you track and understand chronic pain. This policy explains how we collect, use, and protect your personal data in accordance with the EU General Data Protection Regulation (GDPR) and the Finnish Data Protection Act.",
    controllerTitle: "1. Data Controller",
    controllerText:
      "The data controller for Floline is the individual operator of this service. For data protection inquiries, contact us at the email address listed in section 10.",
    dataCollectedTitle: "2. Data We Collect",
    dataCollectedText:
      "We collect the following categories of personal data:",
    dataCollectedAccount: "Account data — email address, display name, language preference",
    dataCollectedHealth:
      "Health data — pain locations, intensity ratings, medications, observations, and other check-in data you provide (special category data under GDPR Art. 9)",
    dataCollectedAudio:
      "Audio recordings — voice check-in recordings, processed for transcription and then deleted per our retention schedule",
    dataCollectedUsage:
      "Usage data — settings, consent records, and technical logs necessary for service operation",
    purposesTitle: "3. Purposes & Legal Basis",
    purposesHealthTracking:
      "Health data tracking and visualization — based on your explicit consent (Art. 9(2)(a))",
    purposesAI:
      "AI-powered transcription and pain data extraction — based on your explicit, separate consent for each AI feature",
    purposesAccount:
      "Account management and authentication — necessary for the performance of the contract (Art. 6(1)(b))",
    purposesSecurity:
      "Security and abuse prevention — our legitimate interest (Art. 6(1)(f))",
    aiProcessingTitle: "4. AI & Automated Processing",
    aiProcessingText:
      "When you enable AI features (audio transcription, AI extraction, AI insights), your data is processed by Azure AI services hosted in the EU. Audio recordings are transcribed to text and the text is analyzed to extract structured pain data. You always review and confirm AI-extracted data before it is saved. You can disable any AI feature at any time in Settings.",
    retentionTitle: "5. Data Retention",
    retentionText:
      "Your pain tracking data is retained as long as your account is active. Audio recordings are deleted after transcription (typically within minutes). You can delete individual records or request full account erasure at any time.",
    sharingTitle: "6. Data Sharing",
    sharingText:
      "We do not sell your data. Your health data is never shared with third parties for marketing purposes. Data is processed by:",
    sharingInfra:
      "Cloud infrastructure providers (Microsoft Azure, EU region) for hosting and AI services",
    sharingAuth:
      "Authentication providers (Microsoft, when you use Microsoft sign-in)",
    rightsTitle: "7. Your Rights",
    rightsText:
      "Under GDPR, you have the right to:",
    rightsAccess: "Access your personal data (Art. 15)",
    rightsRectification: "Rectify inaccurate data (Art. 16)",
    rightsErasure: "Erase your data (\"right to be forgotten\") (Art. 17)",
    rightsPortability: "Data portability — export your data in machine-readable format (Art. 20)",
    rightsRestriction: "Restrict processing (Art. 18)",
    rightsObject: "Object to processing (Art. 21)",
    rightsWithdraw: "Withdraw consent at any time without affecting the lawfulness of prior processing (Art. 7(3))",
    transfersTitle: "8. International Transfers",
    transfersText:
      "All data is stored and processed within the European Economic Area (EEA). If any transfer outside the EEA becomes necessary, we will ensure appropriate safeguards are in place.",
    securityTitle: "9. Security",
    securityText:
      "We protect your data with encryption at rest and in transit, row-level access controls, and regular security reviews. All AI processing occurs server-side; no health data is processed on third-party client-side scripts.",
    contactTitle: "10. Contact & Complaints",
    contactText:
      "For data protection inquiries or to exercise your rights, email: privacy@floline.app. You also have the right to lodge a complaint with the Finnish Data Protection Ombudsman (tietosuoja.fi).",
    termsTitle: "Terms of Service",
    termsIntro:
      "These Terms of Service (\"Terms\") govern your use of Floline (\"the Service\"). By creating an account or using the Service, you agree to these Terms.",
    termsServiceTitle: "1. The Service",
    termsServiceText:
      "Floline is a personal health tracking tool for recording and visualizing pain data. The Service is not a medical device and does not provide medical advice, diagnosis, or treatment recommendations.",
    termsEligibilityTitle: "2. Eligibility",
    termsEligibilityText:
      "You must be at least 16 years old to use the Service. By creating an account, you confirm that you meet this requirement.",
    termsAccountTitle: "3. Your Account",
    termsAccountText:
      "You are responsible for maintaining the security of your account credentials. You must not share your account with others. Notify us immediately if you suspect unauthorized access.",
    termsAcceptableUseTitle: "4. Acceptable Use",
    termsAcceptableUseText:
      "You agree not to misuse the Service, attempt to gain unauthorized access, or use it for any unlawful purpose. We reserve the right to suspend accounts that violate these Terms.",
    termsHealthDisclaimerTitle: "5. Health Disclaimer",
    termsHealthDisclaimerText:
      "The Service provides observational tools only. AI-generated insights are not medical advice. Always consult a qualified healthcare professional for medical decisions. In a medical emergency, contact your local emergency services immediately.",
    termsIPTitle: "6. Intellectual Property",
    termsIPText:
      "The Service, including its design, code, and content, is owned by Floline. Your health data remains yours. You grant us a limited license to process your data solely to provide the Service.",
    termsAvailabilityTitle: "7. Availability & Changes",
    termsAvailabilityText:
      "We aim to keep the Service available but do not guarantee uninterrupted access. We may modify or discontinue features with reasonable notice. Material changes to these Terms will be communicated via the Service.",
    termsLiabilityTitle: "8. Limitation of Liability",
    termsLiabilityText:
      "To the extent permitted by law, our liability is limited to the amount you paid for the Service in the 12 months preceding any claim. We are not liable for indirect, incidental, or consequential damages.",
    termsGoverningLawTitle: "9. Governing Law",
    termsGoverningLawText:
      "These Terms are governed by Finnish law. Disputes are resolved in the courts of Helsinki, Finland, without prejudice to any mandatory consumer protection rights in your country of residence.",
    termsContactTitle: "10. Contact",
    termsContactText:
      "Questions about these Terms? Email: legal@floline.app",
  },
} as const;

export const commonFi = {
  appName: "Floline",
  loading: "Ladataan...",
  nav: {
    mainNavigation: "P\u00e4\u00e4navigaatio",
    mobileNavigation: "Mobiilinavigaatio",
    skipToContent: "Siirry p\u00e4\u00e4sis\u00e4lt\u00f6\u00f6n",
    dashboard: "Koonti",
    home: "Koti",
    aiCheckIn: "AI-kirjaus",
    aiCheckInShort: "AI-kirjaus",
    recordShort: "Nauhoita",
    stopShort: "Pysäytä",
    transcribingShort: "Litteroidaan",
    timeline: "Aikajana",
    journal: "Päiväkirja",
    trends: "Trendit",
    settings: "Asetukset",
  },
  pageTitle: {
    dashboard: "Koonti",
    aiCheckIn: "AI-kirjaus",
    checkIn: "Päivittäinen kirjaus",
    timeline: "Aikajana",
    events: "Päiväkirja",
    trends: "Trendit",
    settings: "Asetukset",
    onboarding: "Perehdytys",
    dataAccess: "Tietojen käyttö",
    login: "Kirjaudu sisään",
    register: "Luo tili",
    privacy: "Tietosuojaseloste",
    terms: "Käyttöehdot",
    default: "Floline",
  },
  dailyNavigation: {
    today: "T\u00e4n\u00e4\u00e4n",
    previous: "Edellinen",
    next: "Seuraava",
    goToToday: "Siirry t\u00e4h\u00e4n p\u00e4iv\u00e4\u00e4n",
    previousDay: "Edellinen p\u00e4iv\u00e4",
    nextDay: "Seuraava p\u00e4iv\u00e4",
  },
  auth: {
    openUserMenu: "Avaa käyttäjävalikko",
    logIn: "Kirjaudu",
    signInWithMicrosoft: "Kirjaudu Microsoft-tililla",
    signInTitle: "Kirjaudu Flolineen",
    signInSubtitle: "Seuraa kipujasi helposti",
    logOut: "Kirjaudu ulos",
    or: "tai",
    modeSignIn: "Kirjaudu",
    modeCreateAccount: "Luo tili",
    emailLabel: "Sähköpostiosoite",
    emailPlaceholder: "sinä@esimerkki.fi",
    inviteCodeLabel: "Kutsukoodi",
    inviteCodePlaceholder: "Syötä kutsukoodisi",
    inviteCodeHint: "Tarvitset kutsukoodin luodaksesi uuden tilin.",
    betaInviteOnlyDisclaimer:
      "Beta-käyttö vain kutsulla: emme ota uusia käyttäjiä ilman voimassa olevaa kutsukoodia.",
    sendLoginLinkButton: "Lähetä kirjautumislinkki",
    sendLoginCodeButton: "Lähetä kirjautumiskoodi",
    createAccountButton: "Luo tili",
    sending: "Lähetetään\u2026",
    magicLinkSentTitle: "Tarkista sähköpostisi",
    magicLinkSentDescription: "Jos osoite on rekisteröity, saat kirjautumislinkin pian.",
    magicLinkSentDescriptionRegister: "Tarkista saapuneet viestisi – kirjautumislinkki on matkalla.",
    otpSentDescription: "Jos osoite on rekisteröity, saat kertakäyttöisen koodin pian.",
    otpSentHint: "Jatka syöttämällä kertakäyttöinen koodi alle.",
    emailAuthExpiresHint: "Koodi vanhenee 5 minuutissa.",
    otpCodeLabel: "Kertakäyttökoodi",
    otpCodePlaceholder: "Syötä 6-numeroinen koodi",
    verifyCodeButton: "Vahvista koodi",
    verifyingCode: "Vahvistetaan...",
    useDifferentEmail: "Käytä eri sähköpostia",
    otpInvalidOrExpired: "Virheellinen tai vanhentunut koodi. Yritä uudelleen.",
    otpTooManyAttempts: "Liian monta yritystä. Pyydä uusi koodi.",
    tryAgain: "Lähetä uusi linkki",
    invalidInviteCode: "Virheellinen kutsukoodi. Tarkista koodi ja yritä uudelleen.",
    genericError: "Jokin meni pieleen. Yritä uudelleen.",
    networkError: "Verkkovirhe. Tarkista yhteys ja yritä uudelleen.",
  },
  actions: {
    save: "Tallenna",
    saving: "Tallennetaan...",
    cancel: "Peruuta",
    back: "Takaisin",
    delete: "Poista",
    deleting: "Poistetaan...",
    yesDelete: "Kyllä, poista",
    saveChanges: "Tallenna muutokset",
    close: "Sulje",
    later: "Myöhemmin",
    install: "Asenna",
    update: "Päivitä",
    dismiss: "Sulje",
    send: "Lähetä",
    confirm: "Vahvista",
  },
  bodyRegions: {
    head_neck: "Pää ja niska",
    shoulder: "Olkapää",
    upper_back: "Yläselkä",
    lower_back: "Alaselkä",
    chest: "Rintakehä",
    abdomen: "Vatsa",
    hip: "Lonkka",
    arm: "Käsivarsi",
    hand: "Käsi",
    leg: "Jalka",
    foot: "Jalkaterä",
    pelvis_groin: "Lantio/Nivunen",
    generalized: "Yleistynyt (koko keho)",
    other: "Muu",
  },
  bodyZones: {
    head_face: "Pää/Kasvot",
    neck: "Niska",
    shoulder: "Olkapää",
    upper_back: "Yläselkä",
    mid_back: "Keskiselkä",
    lower_back: "Alaselkä",
    chest: "Rintakehä",
    upper_abdomen: "Ylävatsa",
    lower_abdomen: "Alavatsa",
    pelvis_groin: "Lantio/Nivunen",
    glute: "Pakara",
    hip: "Lonkka",
    upper_arm: "Olkavarsi",
    elbow: "Kyynärpää",
    forearm: "Kyynärvarsi",
    wrist: "Ranne",
    hand: "Käsi",
    thigh: "Reisi",
    knee: "Polvi",
    lower_leg: "Sääri/Pohje",
    ankle: "Nilkka",
    foot: "Jalkaterä",
    generalized: "Yleistynyt (koko keho)",
    other: "Muu",
  },
  bodySurfaces: {
    front: "Etu",
    back: "Taka",
    both: "Molemmat",
    unknown: "Ei määritelty",
  },
  laterality: {
    left: "Vasen",
    right: "Oikea",
    bilateral: "Molemmat puolet",
    midline: "Keskellä",
    unknown: "Ei määritelty",
  },
  lateralityShort: {
    left: "V",
    right: "O",
    bilateral: "M",
    midline: "K",
    unknown: "?",
  },
  timeOfDay: {
    morning: "Aamu",
    afternoon: "Iltapäivä",
    evening: "Ilta",
    night: "Yö",
    unknown: "Ei määritelty",
  },
  doseUnits: {
    mg: "mg",
    g: "g",
    ml: "mL",
    mcg: "mcg",
    tablet: "tabletti(a)",
    capsule: "kapseli(a)",
    drop: "tippa(a)",
    patch: "laastari",
    other: "muu",
  },
  painQualities: {
    aching: "Särkyvä",
    burning: "Polttava",
    cramping: "Kouristava",
    dull: "Jomottava",
    electric: "Sähköiskumainen",
    hot: "Kuumottava",
    itchy: "Kutiseva",
    numbness: "Puutuminen",
    pins_and_needles: "Pistely",
    pressure: "Paineen tunne",
    sharp: "Terävä",
    shooting: "Säteilevä",
    sore: "Arka",
    stabbing: "Pistävä",
    throbbing: "Sykkivä",
    tingling: "Kihelmointi",
    tight: "Kireä",
  },
  export: {
    buttonLabel: "Vie",
    title: "Vie kiputiedot",
    description: "Luo raportti kipuseurantatiedoistasi.",
    dateRange: "Aikaväli",
    startDate: "Alku",
    endDate: "Loppu",
    dateRangeTooLarge: "Aikaväli ei voi ylittää 365 päivää.",
    format: "Muoto",
    options: "Asetukset",
    includeDetailedData: "Sisällytä yksityiskohtaiset päivätaulukot",
    omitNotes: "Jätä pois henkilökohtaiset muistiinpanot (yksityisyys)",
    generating: "Luodaan...",
    generateExport: "Luo vienti",
    downloadSuccess: "Tiedosto ladattu onnistuneesti!",
    downloadRecords: "({{count}} kirjausta)",
    formatLabels: {
      pdf: "PDF-raportti",
      csv: "CSV-data",
      text: "Tekstiyhteenveto",
    },
    formatDescriptions: {
      pdf: "Kattava raportti terveydenhuollon ammattilaisille",
      csv: "Raakadata taulukkoanalyysia varten",
      text: "Lyhyt yhteenveto nopeaan jakamiseen",
    },
    datePresets: {
      last7days: "7 päivää",
      last30days: "30 päivää",
      last90days: "90 päivää",
      last6months: "6 kuukautta",
      lastYear: "Vuosi",
    },
  },
  painLocationEdit: {
    title: "Muokkaa: {{region}}",
    description: "Muokkaa tämän sijainnin kiputietoja",
    side: "Puoli",
    painLevel: "Kiputaso",
    painScaleMin: "0 - Ei kipua",
    painScaleMax: "10 - Pahin",
    painType: "Kivun tyyppi",
    additionalDetails: "Lisätiedot (valinnainen)",
    detailPlaceholder: "Esim. 'polven takana', 'pahempi aamuisin'...",
    deleteConfirm: "Poistetaanko?",
    failedToSave: "Muutosten tallennus epäonnistui",
    failedToDelete: "Poisto epäonnistui",
    painDescription: {
      none: "Ei kipua",
      mild: "Lievä",
      moderate: "Kohtalainen",
      severe: "Voimakas",
      worst: "Pahin kuviteltavissa",
    },
  },
  manualEntry: {
    title: "Lisää kipukirjaus",
    bodyRegion: "Kehon alue *",
    bodyRegionPlaceholder: "Valitse kehon alue...",
    side: "Puoli",
    surface: "Pinta",
    painIntensity: "Kivun voimakkuus",
    scaleMax: "/ 10",
    scaleMinLabel: "Ei kipua",
    scaleMaxLabel: "Voimakas",
    additionalNotes: "Lisämuistiinpanot (valinnainen)",
    notesPlaceholder: "Lisätietoja kivusta...",
    addToCheckin: "Lisää kirjaukseen",
  },
  dailyRecord: {
    emptyTitle: "Ei kirjattua kipua",
    emptyDescription: "Päivälle {{date}} ei kirjattu kiputietoja.",
    addEntryForDay: "Lisää kirjaus tälle päivälle",
    painFreeTitle: "Kivuton päivä kirjattu",
    painFreeDescription: "{{date}} on kirjattu kivuttomaksi.",
    editDay: "Muokkaa päivää",
    errorTitle: "Kirjauksen lataus epäonnistui",
    bodyHeatmap: "Kehokartta",
    painLocations: "Kipupaikat",
    observations: "Havainnot",
    medications: "Lääkkeet",
    notes: "Muistiinpanot",
    tags: "Tagit",
  },
  pwa: {
    installTitle: "Asenna Floline",
    installDescription: "Seuraa kipujasi offline-tilassa sovelluksella",
    installTitleMobile: "Asenna Floline puhelimeesi",
    installDescriptionMobile: "Sovellus avautuu nopeammin, toimii offline-tilassa ja tekee päivittäisestä kirjauksesta sujuvamman.",
    installIosHint: "iPhonessa: napauta Jaa ja valitse Lisää Koti-valikkoon.",
    statusSyncing: "Synkronoidaan muutoksia...",
    statusPending_one: "{{count}} muutos jonossa",
    statusPending_other: "{{count}} muutosta jonossa",
    statusOffline: "Olet offline-tilassa",
    statusOfflineWillSync_one: "Olet offline-tilassa • {{count}} muutos synkronoidaan, kun yhteys palautuu",
    statusOfflineWillSync_other: "Olet offline-tilassa • {{count}} muutosta synkronoidaan, kun yhteys palautuu",
    updateAvailableTitle: "Päivitys saatavilla",
    updateAvailableDescription: "Uusi versio on valmis asennettavaksi",
    offlineReadyTitle: "Sovellus valmis offline-käyttöön",
    offlineReadyDescription: "Sisältö on tallennettu laitteelle",
  },
  bodyDiagram: {
    front: "Edest\u00e4",
    back: "Takaa",
    showFrontView: "N\u00e4yt\u00e4 etupuoli",
    showBackView: "N\u00e4yt\u00e4 takapuoli",
    diagramInstruction: "Valitse kehon alue napsauttamalla",
    dualViewAriaLabel: "Kivun l\u00e4mp\u00f6kartta kehon etu- ja takan\u00e4kym\u00e4st\u00e4",
    frontDiagram: "Kehon etupuolen kuva",
    backDiagram: "Kehon takapuolen kuva",
  },
  painScale: {
    outOf10: "/ 10",
  },
  errors: {
    // Export errors
    signInToExport: "Kirjaudu sisään luodaksesi viennin",
    invalidDateRange: "Virheellinen aikaväli. Tarkista alku- ja loppupäivämäärät.",
    dateRangeTooLarge: "Aikaväli on liian suuri. Valitse lyhyempi jakso.",
    insufficientData: "Valitulla aikavälillä ei ole riittävästi tietoja viennin luomiseen.",
    exportFailed: "Viennin luonti epäonnistui. Yritä uudelleen.",
    unsupportedExportFormat: "Vientimuoto ei ole tuettu.",
    // Transcription errors
    signInToTranscribe: "Kirjaudu sisään litteroidaksesi ääntä",
    transcriptionUnavailable: "Litterointipalvelu ei ole käytettävissä",
    unsupportedAudioFormat: "Äänimuoto ei ole tuettu litteroinnissa",
    transcriptionFailed: "Äänen litterointi epäonnistui. Yritä uudelleen.",
    // Audio upload errors
    signInToUploadAudio: "Kirjaudu sisään ladataksesi äänitallenteita",
    audioUploadTooLarge: "Tallenne on liian suuri. Enimmäiskoko on 50 Mt",
    unsupportedAudioUploadFormat: "Äänimuotoa ei tueta. Kokeile toista selainta",
    // Extraction errors
    signInToExtract: "Kirjaudu sisään poimimaan kiputiedot",
    extractionUnavailable: "AI-poimintapalvelu ei ole käytettävissä",
    missingTranscript: "Poimintaan ei annettu tekstiä",
    transcriptTooLong: "Teksti on liian pitkä. Lyhennä viestiäsi.",
    extractionFailed: "Kiputietojen poiminta epäonnistui. Yritä uudelleen.",
    invalidAiResponse: "AI-palvelulta saatiin virheellinen vastaus",
    // Consent-gated feature errors
    consentRequired:
      "Toiminto on poistettu käytöstä, kunnes annat suostumuksen asetuksissa.",
    consentRequiredAudioTranscription:
      "Äänilitterointi on poistettu käytöstä, kunnes otat suostumuksen käyttöön asetuksissa.",
    consentRequiredAiExtraction:
      "AI-poiminta on poistettu käytöstä, kunnes otat suostumuksen käyttöön asetuksissa.",
    consentRequiredAiInsights:
      "AI-oivallukset on poistettu käytöstä, kunnes otat suostumuksen käyttöön asetuksissa.",
  },
  exportSummary: {
    noPainData: "Ei kiputietoja",
    avgRange: "Ka: {{avg}}/10, Vaihteluväli: {{min}}-{{max}}/10",
    noLocationsRecorded: "Ei kirjattuja sijainteja",
    noMedicationsRecorded: "Ei kirjattuja lääkkeitä",
    medicationsTracked: "{{count}} lääkettä seurannassa",
    exportFailedStatus: "Vienti epäonnistui ({{status}})",
    exportFailedGeneric: "Viennin luonti epäonnistui. Yritä uudelleen.",
  },
  landing: {
    signIn: "Kirjaudu",
    getStarted: "Aloita",
    overlineBadge: "Kroonisen kivun hallinta",
    headlineMap: "Kartoita kipusi.",
    headlineReclaim: "Ota elämäsi takaisin.",
    subheadline: "Floline muuttaa näkymättömän kivun toiminnalliseksi dataksi. Seuraa kaavoja, tunnista laukaisijoita ja jaa tarkkoja raportteja hoitotiimillesi — kaikki alle 60\u00a0sekunnissa päivässä.",
    ctaStartTracking: "Aloita seuranta ilmaiseksi",
    ctaSeeHow: "Katso miten se toimii",
    cardWeeklyOverview: "Viikkokatsaus",
    cardLive: "Live",
    statAvgLevel: "Ka. taso",
    statTriggers: "Laukaisijat",
    statTrend: "Trendi",
    socialEntries: "kipukirjausta seurattu",
    socialConversations: "raportoivat parempia hoitokeskusteluja",
    socialCheckin: "keskimääräinen päiväkirjaus",
    socialSatisfaction: "käyttäjätyytyväisyys",
    featuresHeading: "Rakennettu ihmisille, jotka elävät kivun kanssa",
    featuresSubheading: "Floline on suunniteltu erityisesti kroonisen ja akuutin kivun seurantaan.",
    featureLogTitle: "60 sekunnin päiväkirjaus",
    featureLogBody: "Kehokartta, voimakkuusliukusäädin, laukaisijat ja muistiinpanot — kaikki yhdessä keskitetyssä kulkussa. Ei turhaa, ei kitkaa.",
    featurePatternsTitle: "Kaavojen älykkyys",
    featurePatternsBody: "Havaitse korrelaatiot kipujen, sään, unen, lääkityksen ja aktiviteettien välillä. Katso mikä todella auttaa — tai haittaa.",
    featureReportsTitle: "Lääkärivalmiit raportit",
    featureReportsBody: "Luo PDF-yhteenvetoja, joista hoitotiimisi todella hyötyy. Muuta 'sattuu' tarkaksi, dataan perustuvaksi keskusteluksi.",
    ctaHeading: "Kipusi ansaitsee tulla",
    ctaHeadingHighlight: "ymmärretyksi",
    ctaSubheading: "Aloita kipuprofiilisi rakentaminen tänään. Ilmainen, yksityinen ja suunniteltu todellisille ihmisille, jotka hallitsevat todellista kipua.",
    ctaCreateAccount: "Luo ilmainen tili",
    footerCopyright: "© {{year}} Floline. Rakennettu empatialla ihmisille, jotka elävät kivun kanssa.",
    footerPrivacy: "Tietosuojaseloste",
    footerTerms: "Käyttöehdot",
  },
  legal: {
    privacyPolicy: "Tietosuojaseloste",
    termsOfService: "Käyttöehdot",
    backToHome: "Takaisin etusivulle",
    lastUpdated: "Päivitetty viimeksi: {{date}}",
    privacyTitle: "Tietosuojaseloste",
    privacyIntro:
      "Floline (\"me\", \"palvelu\") on terveystietosovellus, joka auttaa sinua seuraamaan ja ymmärtämään kroonista kipua. Tämä seloste kertoo, miten keräämme, käytämme ja suojaamme henkilötietojasi EU:n yleisen tietosuoja-asetuksen (GDPR) ja Suomen tietosuojalain mukaisesti.",
    controllerTitle: "1. Rekisterinpitäjä",
    controllerText:
      "Flolinen rekisterinpitäjä on tämän palvelun yksityinen ylläpitäjä. Tietosuojaa koskevissa kysymyksissä ota yhteyttä kohdassa 10 mainittuun sähköpostiosoitteeseen.",
    dataCollectedTitle: "2. Kerättävät tiedot",
    dataCollectedText:
      "Keräämme seuraavia henkilötietoryhmiä:",
    dataCollectedAccount: "Tilitiedot — sähköpostiosoite, näyttönimi, kieliasetus",
    dataCollectedHealth:
      "Terveystiedot — kipupaikat, voimakkuusarviot, lääkitykset, havainnot ja muut kirjaamasi tiedot (GDPR art. 9 mukaisia erityisiä henkilötietoja)",
    dataCollectedAudio:
      "Äänitallenteet — äänikirjaukset, jotka käsitellään litteroinnissa ja poistetaan säilytysaikataulumme mukaisesti",
    dataCollectedUsage:
      "Käyttötiedot — asetukset, suostumustiedot ja palvelun toimintaan tarvittavat tekniset lokit",
    purposesTitle: "3. Käsittelyn tarkoitukset ja oikeusperusta",
    purposesHealthTracking:
      "Terveystietojen seuranta ja visualisointi — perustuu nimenomaiseen suostumukseesi (art. 9(2)(a))",
    purposesAI:
      "AI-pohjainen litterointi ja kiputietojen poiminta — perustuu erilliseen nimenomaiseen suostumukseesi kullekin AI-ominaisuudelle",
    purposesAccount:
      "Tilin hallinta ja tunnistautuminen — sopimuksen täytäntöönpano (art. 6(1)(b))",
    purposesSecurity:
      "Turvallisuus ja väärinkäytösten esto — oikeutettu etumme (art. 6(1)(f))",
    aiProcessingTitle: "4. AI ja automaattinen käsittely",
    aiProcessingText:
      "Kun otat käyttöön AI-ominaisuudet (äänen litterointi, AI-poiminta, AI-oivallukset), tietojasi käsitellään EU:ssa sijaitsevilla Azure AI -palveluilla. Äänitallenteet litteroidaan tekstiksi, ja teksti analysoidaan rakenteellisen kiputiedon poimimiseksi. Tarkistat ja vahvistat AI:n poimimat tiedot aina ennen tallennusta. Voit poistaa minkä tahansa AI-ominaisuuden käytöstä milloin tahansa Asetuksissa.",
    retentionTitle: "5. Tietojen säilytys",
    retentionText:
      "Kipuseurantatietosi säilytetään niin kauan kuin tilisi on aktiivinen. Äänitallenteet poistetaan litteroinnin jälkeen (yleensä minuuteissa). Voit poistaa yksittäisiä merkintöjä tai pyytää koko tilin poistoa milloin tahansa.",
    sharingTitle: "6. Tietojen jakaminen",
    sharingText:
      "Emme myy tietojasi. Terveystietojasi ei koskaan jaeta kolmansille osapuolille markkinointitarkoituksiin. Tietoja käsittelevät:",
    sharingInfra:
      "Pilvi-infrastruktuuripalvelut (Microsoft Azure, EU-alue) isännöintiä ja AI-palveluja varten",
    sharingAuth:
      "Tunnistautumispalvelut (Microsoft, kun käytät Microsoft-kirjautumista)",
    rightsTitle: "7. Oikeutesi",
    rightsText:
      "GDPR:n nojalla sinulla on oikeus:",
    rightsAccess: "Saada pääsy henkilötietoihisi (art. 15)",
    rightsRectification: "Oikaista virheellisiä tietoja (art. 16)",
    rightsErasure: "Poistaa tietosi (\"oikeus tulla unohdetuksi\") (art. 17)",
    rightsPortability: "Tietojen siirrettävyys — vie tietosi koneluettavassa muodossa (art. 20)",
    rightsRestriction: "Rajoittaa käsittelyä (art. 18)",
    rightsObject: "Vastustaa käsittelyä (art. 21)",
    rightsWithdraw: "Peruuttaa suostumus milloin tahansa ilman, että se vaikuttaa aiemman käsittelyn lainmukaisuuteen (art. 7(3))",
    transfersTitle: "8. Kansainväliset siirrot",
    transfersText:
      "Kaikki tiedot tallennetaan ja käsitellään Euroopan talousalueella (ETA). Jos siirto ETA:n ulkopuolelle tulee tarpeelliseksi, varmistamme asianmukaiset suojatoimet.",
    securityTitle: "9. Turvallisuus",
    securityText:
      "Suojaamme tietosi salauksella levossa ja siirron aikana, rivitason pääsynvalvonnalla ja säännöllisillä turvallisuusarvioinneilla. Kaikki AI-käsittely tapahtuu palvelinpuolella; terveystietoja ei käsitellä kolmannen osapuolen asiakaspuolen skripteissä.",
    contactTitle: "10. Yhteydenotto ja valitukset",
    contactText:
      "Tietosuojaan liittyvissä kysymyksissä tai oikeuksiesi käyttämiseksi, sähköposti: privacy@floline.app. Sinulla on myös oikeus tehdä valitus tietosuojavaltuutetulle (tietosuoja.fi).",
    termsTitle: "Käyttöehdot",
    termsIntro:
      "Nämä käyttöehdot (\"ehdot\") säätelevät Flolinen (\"palvelu\") käyttöäsi. Luomalla tilin tai käyttämällä palvelua hyväksyt nämä ehdot.",
    termsServiceTitle: "1. Palvelu",
    termsServiceText:
      "Floline on henkilökohtainen terveydenseurantatyökalu kipujen kirjaamiseen ja visualisointiin. Palvelu ei ole lääkinnällinen laite eikä anna lääketieteellisiä neuvoja, diagnooseja tai hoitosuosituksia.",
    termsEligibilityTitle: "2. Kelpoisuus",
    termsEligibilityText:
      "Sinun on oltava vähintään 16-vuotias käyttääksesi palvelua. Luomalla tilin vahvistat täyttäväsi tämän vaatimuksen.",
    termsAccountTitle: "3. Tilisi",
    termsAccountText:
      "Olet vastuussa tilisi tunnistetietojen turvallisuudesta. Tiliä ei saa jakaa muiden kanssa. Ilmoita meille välittömästi, jos epäilet luvatonta käyttöä.",
    termsAcceptableUseTitle: "4. Hyväksyttävä käyttö",
    termsAcceptableUseText:
      "Sitoudut olemaan väärinkäyttämättä palvelua, yrittämättä luvatonta pääsyä tai käyttämättä sitä laittomiin tarkoituksiin. Pidätämme oikeuden keskeyttää tilit, jotka rikkovat näitä ehtoja.",
    termsHealthDisclaimerTitle: "5. Terveysvastuuvapauslauseke",
    termsHealthDisclaimerText:
      "Palvelu tarjoaa ainoastaan havainnointityökaluja. AI:n tuottamat oivallukset eivät ole lääketieteellisiä neuvoja. Ota aina yhteyttä pätevään terveydenhuollon ammattilaiseen lääketieteellisissä päätöksissä. Hätätilanteessa soita hätänumeroon.",
    termsIPTitle: "6. Immateriaalioikeudet",
    termsIPText:
      "Palvelu, mukaan lukien sen suunnittelu, koodi ja sisältö, on Flolinen omaisuutta. Terveystietosi ovat sinun. Myönnät meille rajoitetun lisenssin käsitellä tietojasi ainoastaan palvelun tarjoamiseksi.",
    termsAvailabilityTitle: "7. Saatavuus ja muutokset",
    termsAvailabilityText:
      "Pyrimme pitämään palvelun saatavilla, mutta emme takaa keskeytymätöntä käyttöä. Voimme muuttaa tai poistaa ominaisuuksia kohtuullisella varoitusajalla. Olennaisista ehtomuutoksista ilmoitetaan palvelun kautta.",
    termsLiabilityTitle: "8. Vastuunrajoitus",
    termsLiabilityText:
      "Lain sallimissa rajoissa vastuumme rajoittuu summaan, jonka olet maksanut palvelusta vaadetta edeltävän 12 kuukauden aikana. Emme vastaa epäsuorista, satunnaisista tai välillisistä vahingoista.",
    termsGoverningLawTitle: "9. Sovellettava laki",
    termsGoverningLawText:
      "Näihin ehtoihin sovelletaan Suomen lakia. Riidat ratkaistaan Helsingin käräjäoikeudessa, rajoittamatta asuinmaasi pakottavia kuluttajansuojaoikeuksia.",
    termsContactTitle: "10. Yhteydenotto",
    termsContactText:
      "Kysymyksiä näistä ehdoista? Sähköposti: legal@floline.app",
  },
} as const;
